import { render, staticRenderFns } from "./Terminais.vue?vue&type=template&id=04b29f6b"
import script from "./Terminais.vue?vue&type=script&lang=js"
export * from "./Terminais.vue?vue&type=script&lang=js"
import style0 from "./Terminais.vue?vue&type=style&index=0&id=04b29f6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports